import "../css/ContactUsSection.css"
import colors from '../colors';

function ContactUsSection()
{
    return(
        <div id="contact-section">

        <div id="contact-container">
            <img src={ require('../images/contact_us_icon.png')} style={{width:'100px',height:'100px'}}  alt={process.env.REACT_APP_ALT}/>
            <h2 className="contact-title">با ما تماس بگیرید</h2>
            <p>از راه های ارتباطی زیر با ما در تماس باشید</p>

            <span id="contact-box">
            <span>
            +(98)9352333881
                  <img src={ require('../images/contact1.png') } style={{width:'30px',height:'30px'}} alt={process.env.REACT_APP_ALT}/>
                  </span>

                  <span>
                    +(98)9352333881
                    <img src={ require('../images/contact2.png') } style={{width:'30px',height:'30px'}} alt={process.env.REACT_APP_ALT}/>
                  </span>

                  <span>
                    info@harfbeharf.com
                  <img src={ require('../images/contact3.png') } style={{width:'30px',height:'30px'}} alt={process.env.REACT_APP_ALT}/>
                  </span>

            </span>
            {/* <div style={{width:'50%',display:'table',margin:'auto'}}> */}

            {/* <span id="contact-box" >
            

                  <span style={{display:'flex',alignItems:'center',gap:'10px'}}>
                  تهران، خیابان نوبنیاد، خیابان گلزار جنوبی، کوچه لادن شرقی، 12 متری ولیعصر، بن بست قائم، پلاک 7
                  <img src={ require('../images/contact3.png') } style={{width:'30px',height:'30px'}} />
                  </span>

            </span> */}

            {/* </div> */}

                  

        </div>


      </div>
    );
}

export default ContactUsSection;